import {
  addExternalGuest,
  addGuest,
  calculatePrice,
  cancelBooking,
  checkCancelFeasibility,
  checkGuestList,
  clearBooking,
  editBookingSlot,
  getAmenities,
  getBookingEvents,
  getBookingSlot,
  getCalendarParticipant,
  getGuestList,
  getPaymentStatus,
  getQuoteInfo,
  getTokenizationStatus,
  getUpcomingBookings,
  getUserFavourites,
  removeUserFavourites,
  saveBookingSlot,
  syncUser,
  toggleFavouriteClub,
} from "./booking.service";
import { getContactPerson } from "./contactPerson.service";
import {
  checkConnectivity,
  checkUserPin,
  configureKiosk,
  getKioskBookingSlot,
  getLandingPage,
  getOrganisationInfo,
  loginKioskUser,
} from "./kiosk.service";
import { getLocation } from "./organisation.service";
import { getUnitDetails } from "./unit.service";
import {
  accountDeletion,
  checkAccountDeletion,
  checkInvitationPageShow,
  createUserDetails,
  deletePaymentMethod,
  deleteTempHouseholdMember,
  getKioskSetupData,
  getMemberClubs,
  getMemberInfo,
  getOrganisationList,
  getOrganizationsMetaData,
  getPasswordTokenValid,
  getPublicBookingDetails,
  getRegisterOptions,
  getRegistrationInvitation,
  getTokenisationPaymentMethods,
  getTokenisationSaveCards,
  getUserBookingDetails,
  getUserBookings,
  getUserMemberships,
  getUserProfile,
  getUserSelectedLanguage,
  getUserUpdatePaymentStatus,
  invitedSetPassword,
  login,
  loginAccess,
  loginUser,
  logOut,
  mailVerification,
  makeDefaultPaymentMethod,
  notificationDisable,
  notificationEnable,
  notificationSubscribe,
  notificationUnsubscribe,
  postHouseholdIndividualPin,
  resendMailVerification,
  resetPassword,
  setHouseholdIndividualPin,
  setHouseholdShareMyPin,
  setPassword,
  setProfilePin,
  updateUserLanguage,
  updateUserProfile,
} from "./user.service";

const API_SERVICES = {
  BOOKING: {
    ADD_EXTERNAL_GUEST: addExternalGuest,
    ADD_GUEST: addGuest,
    CALCULATE_PRICE: calculatePrice,
    CANCEL_BOOKING: cancelBooking,
    CHECK_CANCEL_FEASIBILITY: checkCancelFeasibility,
    CHECK_GUEST_LIST: checkGuestList,
    CLEAR_BOOKING: clearBooking,
    EDIT_BOOKING: editBookingSlot,
    GET_AMENITIES: getAmenities,
    GET_BOOKING_EVENTS: getBookingEvents,
    GET_BOOKING_EVENTS_PARTICIPANT: getCalendarParticipant,
    GET_BOOKING_SLOT: getBookingSlot,
    GET_GUEST_LIST: getGuestList,
    GET_QUOTE_INFO: getQuoteInfo,
    GET_UPCOMING_BOOKINGS: getUpcomingBookings,
    GET_USER_FAVOURITES: getUserFavourites,
    PAYMENT_STATUS: getPaymentStatus,
    REMOVE_USER_FAVOURITES: removeUserFavourites,
    SAVE_BOOKING: saveBookingSlot,
    TOGGLE_FAVOURITE_CLUB: toggleFavouriteClub,
    TOKENIZATION_STATUS: getTokenizationStatus,
    USER_SYNC: syncUser,
  },
  CONTACT_PERSON: { GET_CONTACT_PERSON: getContactPerson },
  DASHBOARD: {
    META_DATA: getOrganizationsMetaData,
    ORGANIZATION_FINDER: getOrganisationList,
  },
  KIOSK: {
    CHECK_CONNECTIVITY: checkConnectivity,
    CHECK_USER_PIN: checkUserPin,
    CONFIGURE: configureKiosk,
    GET_BOOKING_SLOT: getKioskBookingSlot,
    LANDING_PAGE: getLandingPage,
    LOGIN_USER: loginKioskUser,
    ORGANISATION_INFO: getOrganisationInfo,
  },
  LOGIN: login,
  LOGIN_ACCESS: loginAccess,
  LOGIN_USER: loginUser,
  MAIL_VERIFICATION: mailVerification,
  NOTIFICATION: {
    DISABLE: notificationDisable,
    ENABLE: notificationEnable,
    SUBSCRIBE: notificationSubscribe,
    UNSUBSCRIBE: notificationUnsubscribe,
  },
  ORGANISATION: {
    GET_LOCATION: getLocation,
  },
  RESEND_MAIL_VERIFICATION: resendMailVerification,
  RESET_PASSWORD: resetPassword,
  UNIT: {
    DETAILS: getUnitDetails,
  },
  USER: {
    ACCOUNT_DELETE: accountDeletion,
    CHECK_ACCOUNT_DELETE: checkAccountDeletion,
    CHECK_INVITATION_PAGE_SHOW: checkInvitationPageShow,
    DELETE_PAYMENT_METHOD: deletePaymentMethod,
    DELETE_TEMP_HOUSEHOLD_MEMBER: deleteTempHouseholdMember,
    GET_KIOSK_SETUP_DATA: getKioskSetupData,
    GET_MEMBER_CLUBS: getMemberClubs,
    GET_MEMBER_INFO: getMemberInfo,
    GET_PUBLIC_BOOKING_DETAILS: getPublicBookingDetails,
    GET_REGISTER_OPTIONS: getRegisterOptions,
    GET_TOKENISATION_PAYMENT_METHODS: getTokenisationPaymentMethods,
    GET_TOKENISATION_SAVE_CARDS: getTokenisationSaveCards,
    GET_USER_BOOKING_DETAILS: getUserBookingDetails,
    GET_USER_BOOKINGS: getUserBookings,
    GET_USER_DETAILS: createUserDetails,
    GET_USER_MEMBERSHIPS: getUserMemberships,
    GET_USER_PROFILE: getUserProfile,
    GET_USER_UPDATE_PAYMENT_STATUS: getUserUpdatePaymentStatus,
    INVITED_USER_SET_PASSWORD: invitedSetPassword,
    LOG_OUT: logOut,
    LOGIN: login,
    LOGIN_ACCESS: loginAccess,
    LOGIN_USER: loginUser,
    MAIL_VERIFICATION: mailVerification,
    MAKE_DEFAULT_PAYMENT_METHOD: makeDefaultPaymentMethod,
    POST_HOUSEHOLD_INDIVIDUAL_PIN: postHouseholdIndividualPin,
    PROFILE: getUserProfile,
    REGISTRATION_INVITATION: getRegistrationInvitation,
    RESEND_MAIL_VERIFICATION: resendMailVerification,
    RESET_PASSWORD: resetPassword,
    RESET_PASSWORD_TOKEN_VALIDITY: getPasswordTokenValid,
    SELECTED_LANGUAGE: getUserSelectedLanguage,
    SET_HOUSEHOLD_INDIVIDUAL_PIN: setHouseholdIndividualPin,
    SET_HOUSEHOLD_SHARE_MY_PIN: setHouseholdShareMyPin,
    SET_PASSWORD: setPassword,
    SET_PROFILE_PIN: setProfilePin,
    UPDATE_LANGUAGE: updateUserLanguage,
    UPDATE_USER_PROFILE: updateUserProfile,
  },
};

export default API_SERVICES;
